export const texasCommunityCollegeArticle = {
  slug: "texas-community-college",
  number: "01-1",
  icon: "ri-map-pin-2-line",
  category: "コミカレの始め方",
  parentSlug: "community-college",
  parentLabel: "コミカレの始め方",
  title: "テキサス州のコミカレ選び",
  lead: "テキサス州のコミュニティカレッジを選ぶときに見ておきたいポイントを、学校の仕組み・比較の観点・費用と住まいの確認方法・留学生の出願条件・編入を見据えた選び方の順にまとめました。",
  updatedAt: "2026.10.26",
  blocks: [
    {
      kind: "note",
      title: "このページについて",
      text: "制度の基本と「確認のしかた」をまとめた無料記事です。学校名や運営者の在籍校は掲載していません。学費・出願条件・寮の有無は学校ごとに異なるため、必ず志望校の公式サイトで最終確認してください。",
    },
    { kind: "h", text: "コミュニティカレッジの基本的な仕組み" },
    {
      kind: "p",
      text: "コミュニティカレッジ（コミカレ）は、主に2年制のカレッジです。修了すると準学士（Associate degree）などの資格が得られ、4年制大学の最初の2年分に近い一般教養や基礎科目が用意されていることが多く、アメリカ留学の入口として選ばれることがあります。",
    },
    {
      kind: "list",
      items: [
        "テキサス州の公立コミカレは、州内の複数の地域でコミュニティカレッジ・ディストリクトとして運営されている",
        "準学士には、編入を想定した Associate of Arts / Associate of Science と、就職向けの Associate of Applied Science などがある",
        "州全体で共通のコアカリキュラム（Texas Core Curriculum）が定められており、一般教養の枠組みがそろっている",
        "州内で科目番号を共通化する仕組み（TCCNS）や、専攻分野ごとの推奨科目（Field of Study Curriculum）が用意されている",
        "留学生はF-1ビザ（学生ビザ）で通学し、就労には制限がある",
      ],
    },
    {
      kind: "note",
      title: "州の枠組みは「参考」です",
      text: "州共通のコアや科目番号の仕組みは、編入を考えるうえで参考になります。ただし、取得した単位がすべて編入先の卒業要件に使えるとは限らず、最終的な判断は編入先の大学が行います。",
    },
    { kind: "h", text: "学校を選ぶときの比較ポイント" },
    {
      kind: "p",
      text: "学校名の知名度より、「自分が何をしたいか」と「確認できる情報が公開されているか」で比べるほうが、選びやすくなります。次の観点で表にまとめると比較しやすくなります。",
    },
    {
      kind: "table",
      head: ["観点", "確認すること"],
      rows: [
        ["認証", "地域認証機関（テキサス州の公立校はSACSCOCなど）の認証を受けているか"],
        ["専攻・科目", "希望分野の科目がそろっているか、Field of Study Curriculumに対応した科目があるか"],
        ["留学生対応", "国際学生オフィス（DSO）があり、ビザや履修の相談ができるか"],
        ["英語力要件", "受け付ける試験の種類、求められるスコア、免除の条件"],
        ["学費", "留学生（international / out-of-state）の単価と、追加の諸費用"],
        ["規模・環境", "学生数、クラスサイズ、キャンパスの立地、日本人留学生の人数"],
        ["住まい・通学", "寮の有無、周辺の家賃、車が必要か、公共交通や駐車の条件"],
        ["編入の支援", "トランスファーアドバイザー、編入ガイド、編入先との連携の有無"],
      ],
    },
    {
      kind: "note",
      title: "比較表は自分でつくるのがおすすめ",
      text: "公式サイトの情報は学校ごとに項目や表現が違うため、同じ観点で並べた表があると判断しやすくなります。比較用のテンプレートは、有料PDFガイドで公開する予定です（現在準備中）。",
    },
    { kind: "h", text: "学費の確認方法" },
    {
      kind: "list",
      items: [
        "学校公式サイトの Tuition & Fees（学費）ページを開き、留学生・州外学生の単価（per credit hour）を探す",
        "1学期あたりの履修単位数（例：12〜15単位）と学期数から、1年間の学費の目安を計算する",
        "授業料以外の費用（施設費、テクノロジー費、保険、学生活動費など）が別枠でないか確認する",
        "Cost of Attendance（年間にかかる費用の目安）が公表されていれば、学費と生活費の合計を確認する",
        "教材費・機材費・実習費など、専攻によって追加になる費用を確認する",
        "出願料、SEVIS（I-901）手数料、ビザ申請料、渡航費は学費とは別に必要",
      ],
    },
    {
      kind: "note",
      title: "当サイトでは金額を掲載していません",
      text: "学費は学校・年度・専攻で変わり、為替でも日本円の負担が変わります。確認が取れていない金額を推測で掲載することはしないため、当サイトでは具体的な金額を出さず、確認手順のみを紹介しています。",
    },
    { kind: "h", text: "生活費の確認方法" },
    {
      kind: "list",
      items: [
        "住居費：寮の料金表、または周辺アパートの相場（学校の住まいページや地域の賃貸情報）",
        "食費：寮の食事プランに含まれるか、自炊前提かで大きく変わる",
        "健康保険：学校指定の保険に加入が必要か、費用はいくらか",
        "交通費：車が必要な地域か、公共交通やスクールバスの有無",
        "教科書・機材：中古・レンタル・電子版の選択肢があるか",
        "渡航費・ビザ関連費用：渡米前後に必ず発生する費用として別枠で見積もる",
      ],
    },
    { kind: "h", text: "学生寮と通学環境の確認方法" },
    {
      kind: "list",
      items: [
        "留学生が入れる寮があるか（年齢条件、食事プラン、契約期間）",
        "寮費に何が含まれるか（家具、光熱費、インターネット、食事）",
        "寮がない場合、大学周辺のアパート事情とルームメイトの探し方",
        "車が必要かどうか、公共交通・スクールバス・駐車許可の条件",
        "徒歩圏にスーパー・病院・銀行があるか",
        "気候（テキサス州は地域によって差が大きい）と、それに合った服装・移動手段",
        "キャンパス警察が公開している治安情報などの公式資料",
      ],
    },
    {
      kind: "note",
      title: "「寮がある」＝「留学生が入れる」ではありません",
      text: "寮の有無と、留学生が入居できるかは別の情報です。住まいのページと国際学生向けページの両方を確認してください。",
    },
    { kind: "h", text: "留学生向けの出願条件" },
    {
      kind: "p",
      text: "必要な書類は学校ごとに異なりますが、留学生向けの出願では次のような書類が求められることが一般的です。",
    },
    {
      kind: "list",
      items: [
        "高校の卒業証明・成績証明書（英文、または公式の英訳）",
        "英語力の証明（TOEFL iBT、IELTS Academic、Duolingo English Test など。受け付ける試験と基準は学校ごとに異なる）",
        "財政証明（学費と生活費を賄えることを示す銀行残高証明など）",
        "パスポートのコピー",
        "出願料",
        "予防接種の記録（学校によって必要）",
        "学校によってはエッセイや推薦状",
        "入学後のプレイスメント（テキサス州の公立校ではTSIA2などが案内される）",
      ],
    },
    {
      kind: "note",
      title: "出願年度の公式ページを見てください",
      text: "出願条件・締切・必要書類は毎年見直されます。International Students（留学生）向けのページと、出願チェックリストのPDFがある場合はそちらを優先して確認してください。",
    },
    { kind: "h", text: "4年制大学への編入を考えた学校選び" },
    {
      kind: "p",
      text: "編入を視野に入れるなら、「通いやすさ」だけでなく「編入先につながりやすいか」を最初から確認しておくと、あとで履修の組み直しが減ります。",
    },
    {
      kind: "list",
      items: [
        "希望分野のField of Study Curriculumに対応した科目が用意されているか",
        "編入先が求める前提科目（prerequisites）を1年目から履修できるか",
        "トランスファーアドバイザーや編入ガイド、編入先との連携（articulation）があるか",
        "州内の4年制大学への編入を考える場合、州共通のコアに沿って履修できるか",
        "GPAを維持しやすい環境か（クラスサイズ、チュータリング、補習の仕組み）",
        "編入後に必要単位数が増えないよう、早い段階で単位評価の相談ができるか",
      ],
    },
    {
      kind: "note",
      title: "編入は保証されません",
      text: "コミカレから4年制大学への編入は自動的に決まるものではなく、改めて出願して審査を受けます。必要GPA・単位数・出願資格は大学や専攻によって異なり、年度ごとに見直されます。",
    },
    {
      kind: "pending",
      title: "学校比較テンプレート（準備中）",
      text: "上の比較ポイントを同じ形式で並べられるテンプレートを、有料PDFガイドとして準備しています。完成までは購入できません。",
    },
    {
      kind: "cta",
      title: "次に読む：英語力証明試験",
      text: "出願に必要なTOEFL iBT・Duolingo English Test・IELTS Academicの基本と、TSIA2との違いをまとめています。",
      to: "/learn/english-test",
      label: "英語力証明試験を読む",
    },
    {
      kind: "source",
      items: [
        {
          label: "テキサス州高等教育委員会（THECB）",
          url: "https://www.highered.texas.gov/",
          checkedAt: "2026.10.26",
          terms: "州の公式サイト。制度の枠組み確認のみに使用し、本文・図表の転載は行っていません。",
        },
        {
          label: "Texas Common Course Numbering System（TCCNS）",
          url: "https://tccns.org/",
          checkedAt: "2026.10.26",
          terms: "州内の科目番号共通化の公式サイト。リンク紹介のみで、内容の転載は行っていません。",
        },
        {
          label: "Southern Association of Colleges and Schools Commission on Colleges（SACSCOC）",
          url: "https://sacscoc.org/",
          checkedAt: "2026.10.26",
          terms: "地域認証機関の公式サイト。認証状況の確認方法の参照のみに使用しています。",
        },
        {
          label: "Study in the States（米国国土安全保障省）",
          url: "https://studyinthestates.dhs.gov/students",
          checkedAt: "2026.10.26",
          terms: "政府公式サイト。留学生の制度確認に使用し、文章の転載は行っていません。",
        },
      ],
    },
  ],
};